<div class="col-12 login-container">
  <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="title">
      <span class="text">{{ config()?.productName }}</span>
    </div>

    @if (loginError) {
      <div>
        <div class="alert alert-danger" data-test="login-alert">
          {{ 'auth.sign-in.error' | translate }}
        </div>
      </div>
    }

    <div class="d-flex flex-column">
      <cap-input
        formControlName="email"
        [label]="'auth.sign-in.email' | translate"
        [placeholder]="'auth.sign-in.email' | translate"
        styleClass="w-100"
        data-test="email" />

      <cap-password
        formControlName="password"
        [showIcon]="'fal fa-eye'"
        [toggleMask]="true"
        [label]="'auth.sign-in.password' | translate"
        [placeholder]="'auth.sign-in.password' | translate"
        styleClass="w-100" />
    </div>

    <div>
      <cap-input-switch
        formControlName="remember"
        [label]="'auth.sign-in.remember' | translate"
        [styleClass]="'switch'"
        data-test="remember-switch" />
    </div>

    <div class="action-container">
      <div class="login-actions d-flex align-items-center gap-3">
        <cap-button
          type="submit"
          styleClass="primary"
          data-test="login-button"
          [label]="'auth.sign-in.button' | translate" />

        <cap-button
          styleClass="secondary"
          data-test="login-sso-button"
          (onClick)="loginSSO()"
          [label]="'LeadPortal.auth.sign-in-sso.button' | translate" />
      </div>

      <div [class.forgot-pass-mobile]="isMobile()" class="d-flex align-items-center gap-3">
        <span class="login-separator">{{ 'auth.sign-in.or-label' | translate }}</span>

        <a routerLink="/auth/forgot-password" class="login-link" data-test="forgot-password-link">
          {{ 'auth.sign-in.password-forgot' | translate }}
        </a>
      </div>
    </div>
  </form>
</div>
